/* ============================================================
   FAQ Akkordeon — Verhalten
   Datei: assets/faq-akkordeon.js

   Sorgt dafür, dass immer nur eine Frage gleichzeitig offen ist
   (falls in der Section aktiviert). Das Auf- und Zuklappen selbst
   macht der Browser über <details> — ohne JavaScript funktioniert
   das Akkordeon also weiterhin.
   ============================================================ */

(function () {
  'use strict';

  function initAccordion(root) {
    if (!root || root.dataset.faqInit === 'true') return;
    root.dataset.faqInit = 'true';

    if (root.dataset.singleOpen !== 'true') return;

    var items = root.querySelectorAll('.faq-akkordeon__item');

    items.forEach(function (item) {
      item.addEventListener('toggle', function () {
        if (!item.open) return;
        items.forEach(function (other) {
          if (other !== item) other.open = false;
        });
      });
    });
  }

  function initAll(scope) {
    (scope || document)
      .querySelectorAll('.faq-akkordeon')
      .forEach(initAccordion);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', function () {
      initAll();
    });
  } else {
    initAll();
  }

  /* Theme-Editor: Section wurde neu geladen oder hinzugefügt */
  document.addEventListener('shopify:section:load', function (event) {
    initAll(event.target);
  });
})();